import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export type ScoreBand = "green" | "amber" | "red";

/** Fixed bands in v1 (green >= 80 = default threshold, amber 60-79, red < 60).
 *  Swapping to the brand's live threshold later is a one-line change at the
 *  call sites. */
export function scoreBand(score: number): ScoreBand {
  if (score >= 80) return "green";
  if (score >= 60) return "amber";
  return "red";
}

const BAND_CLASSES: Record<ScoreBand, string> = {
  green: "text-green-400 border-green-500/20",
  amber: "text-amber-400 border-amber-500/20",
  red: "text-red-400 border-red-500/20",
};

interface AiScoreBadgeProps {
  score?: number | null;
  className?: string;
}

export function AiScoreBadge({ score, className }: AiScoreBadgeProps) {
  const { t } = useTranslation("ui");
  if (typeof score !== "number" || !Number.isFinite(score)) return null;
  return (
    <Badge
      variant="outline"
      className={cn("gap-1 font-mono", BAND_CLASSES[scoreBand(score)], className)}
    >
      <Sparkles size={10} className="flex-shrink-0" />
      <span>{t("aiScoreBadge.label", { score })}</span>
    </Badge>
  );
}
